import _ from 'underscore';
import PropTypes from 'prop-types';
import { useContext, useMemo } from 'react';
import { useWizardService, getCurrentStepId } from '@bingads-webui-react/wizard-core';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';
import { useLogEnteredPage } from './step-flow-provider-with-context';

export const StepLogger = ({
  flow, subflow, stepToPage,
}) => {
  const { state } = useWizardService();
  const currentStepId = getCurrentStepId(state);
  const instrumentation = useContext(InstrumentationContext);
  const activity = useMemo(() => {
    if (instrumentation && instrumentation.stepFlowScenario) {
      const scenario = instrumentation.stepFlowScenario.create();
      return scenario.stepFlow.create();
    }
    return { trace: _.noop, error: _.noop };
  }, [instrumentation]);

  if (!stepToPage[currentStepId]) {
    activity.error(`Cannot find the step name from stepToPage: ${currentStepId}`);
  }

  useLogEnteredPage({ Flow: flow, SubFlow: subflow, Page: stepToPage[currentStepId] || 'unknown step' });

  return null;
};

StepLogger.propTypes = {
  flow: PropTypes.string.isRequired,
  stepToPage: PropTypes.shape({}).isRequired,
  subflow: PropTypes.string.isRequired,
};
